import { useState, useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';

export default function ApprovalPage() {
  const { token } = useParams();
  const [searchParams] = useSearchParams();
  const action = searchParams.get('action'); // 'approve' or 'reject'

  const [status, setStatus] = useState('loading'); // loading, confirm, processing, done, error
  const [approverName, setApproverName] = useState('');
  const [resultMessage, setResultMessage] = useState('');
  const [projectName, setProjectName] = useState('');
  const [responseStatus, setResponseStatus] = useState('');

  useEffect(() => {
    if (!token || !action) {
      setStatus('error');
      setResultMessage('Invalid approval link.');
      return;
    }
    if (action !== 'approve' && action !== 'reject') {
      setStatus('error');
      setResultMessage('Invalid action. Must be approve or reject.');
      return;
    }
    setStatus('confirm');
  }, [token, action]);

  const handleSubmit = async () => {
    if (!approverName.trim()) {
      alert('Please enter your name.');
      return;
    }

    setStatus('processing');

    try {
      const response = await fetch('/.netlify/functions/process-approval', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          token,
          action,
          approverName: approverName.trim()
        })
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.error || 'Failed to process approval');
      }

      setResultMessage(result.message);
      setProjectName(result.projectName || '');
      setResponseStatus(result.status || action);
      setStatus('done');
    } catch (error) {
      console.error('Approval error:', error);
      setStatus('error');
      setResultMessage(error.message);
    }
  };

  const isApprove = action === 'approve';
  const actionColor = isApprove ? '#4CAF50' : '#F44336';
  const actionText = isApprove ? 'Approve' : 'Reject';

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#f5f5f5',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      fontFamily: 'Arial, sans-serif',
      padding: '20px'
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '12px',
        padding: '40px',
        width: '500px',
        maxWidth: '90vw',
        boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
        textAlign: 'center'
      }}>
        {/* Header */}
        <div style={{
          backgroundColor: actionColor,
          margin: '-40px -40px 30px -40px',
          padding: '25px',
          borderRadius: '12px 12px 0 0'
        }}>
          <h1 style={{ color: 'white', margin: 0, fontSize: '22px' }}>
            WPS STP Application
          </h1>
          <p style={{ color: 'rgba(255,255,255,0.9)', margin: '5px 0 0 0', fontSize: '14px' }}>
            Project {actionText} Request
          </p>
        </div>

        {/* Loading */}
        {status === 'loading' && (
          <p style={{ color: '#666', fontSize: '16px' }}>Loading...</p>
        )}

        {/* Confirmation form */}
        {status === 'confirm' && (
          <div>
            <p style={{ color: '#333', fontSize: '16px', marginBottom: '20px' }}>
              You have been asked to <strong style={{ color: actionColor }}>{actionText.toLowerCase()}</strong> a project.
            </p>
            <p style={{ color: '#666', fontSize: '14px', marginBottom: '25px' }}>
              Please enter your name below to confirm your decision.
            </p>

            <input
              type="text"
              value={approverName}
              onChange={(e) => setApproverName(e.target.value)}
              placeholder="Enter your full name"
              style={{
                width: '100%',
                padding: '12px',
                border: '2px solid #ddd',
                borderRadius: '6px',
                fontSize: '16px',
                marginBottom: '20px',
                boxSizing: 'border-box'
              }}
            />

            <button
              onClick={handleSubmit}
              style={{
                width: '100%',
                padding: '14px',
                backgroundColor: actionColor,
                color: 'white',
                border: 'none',
                borderRadius: '6px',
                fontSize: '16px',
                fontWeight: 'bold',
                cursor: 'pointer'
              }}
            >
              Confirm {actionText}
            </button>
          </div>
        )}

        {/* Processing */}
        {status === 'processing' && (
          <p style={{ color: '#666', fontSize: '16px' }}>Processing your response...</p>
        )}

        {/* Done */}
        {status === 'done' && (
          <div>
            <div style={{
              fontSize: '60px',
              marginBottom: '15px'
            }}>
              {responseStatus === 'approved' ? '\u2713' : '\u2717'}
            </div>
            <h2 style={{ color: '#333' }}>{resultMessage}</h2>
            {projectName && (
              <p style={{ color: '#666', fontSize: '14px' }}>Project: {projectName}</p>
            )}
            <p style={{ color: '#999', fontSize: '13px', marginTop: '30px' }}>
              You can close this window.
            </p>
          </div>
        )}

        {/* Error */}
        {status === 'error' && (
          <div>
            <div style={{ fontSize: '60px', marginBottom: '15px', color: '#F44336' }}>!</div>
            <h2 style={{ color: '#F44336' }}>Error</h2>
            <p style={{ color: '#666' }}>{resultMessage}</p>
          </div>
        )}
      </div>
    </div>
  );
}
